export const getStockState = (state) => state.stocks
export const getScrollStock = (state) => state.stockScroll
export const getScrollStockMeta= (state) => state.stockScrollMeta
export const getScrollStockCount = (state) => state.stockScrollCount